<div class="container container-slim">
  <div class="row">
    <div class="col-md-12">
      <h3 class="text-login text-login-default">{{langSafe('Account löschen', 'Unregistration')}}</h3>
    </div>
  </div>
  <div class="row text-center">
    <div class="col-sm-12 info" [innerHTML]="langSafe('Schade, dass du dich abmeldest. Falls du deine Abmeldung bestätigst, löschen wir dauerhaft deine bei Leada hinterlegten Daten,
       z.B. zu deiner persönlichen Entwicklung (Reflexionen) oder zur Verfolgung und Erreichung von Zielen.
       Du erhältst auch keine monatliche Auswertung deiner Performance mehr.',
       'We\'re sorry to see you go! If you confirm your unsubscription, we will permanently delete your data stored at Leada,
       e.g. on your personal development (reflections) or on the tracking and achievement of goals.
       You will also no longer receive a monthly evaluation of your performance.', true)">
    </div>
  </div>
    <form (ngSubmit)="onSubmit()" ngNativeValidate>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <div class="input-group">
              <span class="input-group-addon"><i class="glyphicon glyphicon-user"></i></span>
              <input type="email" class="form-control" name="email" id="inputEmail" [(ngModel)]="userInfo.email" placeholder="{{langSafe('E-Mail', 'Email')}}" required>
            </div>
          </div>
        </div>
      </div>
      <div class="row" *ngIf= 'userInfo.code == null'>
        <div class="col-md-12">
          <div class="form-group">
            <div class="input-group">
              <span class="input-group-addon"><i class="glyphicon glyphicon-lock"></i></span>
              <input type="password" class="form-control" name="password" id="inputPassword" [(ngModel)]="userInfo.password" placeholder="{{langSafe('Passwort', 'Password')}}" required>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div *ngIf="error" class="alert alert-danger" role="alert">
            <span class="glyphicon glyphicon-exclamation-sign"></span>
            {{error}}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <button type="button" class="btn btn-secondary btn-block" (click)="onCancel()">
              {{langSafe('Abbrechen', 'Cancel')}}
            </button>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <button type="submit" class="btn btn-primary btn-block">
              {{langSafe('Fortfahren', 'Continue')}}
            </button>
          </div>
        </div>
      </div>
  </form>
</div>
